"use client";

import { defaultLocale, isLocale } from "@/i18n/config";
import { localizeHref } from "@/i18n/navigation";
import { useLocale } from "next-intl";
import NextLink from "next/link";
import type { ComponentProps } from "react";

type NextLinkProps = ComponentProps<typeof NextLink>;

// Drop-in replacement for next/link that keeps the active locale prefix on
// internal navigation (so a click inside /az doesn't drop you back to tr).
// Swap `import Link from "next/link"` -> `from "@/components/localized-link"`.
export default function Link({ href, ...props }: NextLinkProps) {
    const rawLocale = useLocale();
    const locale = isLocale(rawLocale) ? rawLocale : defaultLocale;
    const localizedHref =
        typeof href === "string" ? localizeHref(href, locale) : href;
    return <NextLink href={localizedHref} {...props} />;
}
